<template>
    <div class="quickscan-incomplete">
        <h1>Aanvraagverzoek</h1>
        <h2>Aanvraag niet volledig</h2>

        <quickscan-stepper :current-step="3" :loading="false">
            <p>De aanvraag kan pas ingediend worden wanneer alle gegevens zijn ingevuld.</p>

            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-btn @click="back">Terug</v-btn>
                </v-col>
            </v-row>
        </quickscan-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import QuickscanStepper from '../components/QuickscanStepper';

export default {
    name: 'quickscan-incomplete',
    components: {
        QuickscanStepper,
    },
    data: () => ({}),
    computed: {
        ...mapGetters(['quickscan']),
    },
    destroyed() {
        // reset error state when navigating away from page
        this.quickscanFinishReset();
    },
    methods: {
        ...mapActions(['quickscanFinishReset']),
        back() {
            this.$router.push({ name: 'quickscan_step2' });
        },
    },
};
</script>
